<template>
  <div class="u-center flex-col w-[257px] h-[325px] p-6 bg-tr text-white base">
    <div class="u-center w-full mb-4">
      <OIcon icon="recent" svg-class="pr-[5px]" />
      <p>Geçmiş Oyunları Oyna!</p>
    </div>

    <div
      v-for="game in games"
      :key="game.id"
      class="u-center rounded-md mt-1 h-11 py-0.5 pl-3 pr-1.5 justify-between text-13 w-full"
      style="border: 2px solid rgba(255, 255, 255, 0.1)"
    >
      <div class="font-normal">{{ _gameName }} #{{ paddedNumber(game.gameNumber) }}</div>
      <OButton
        pure
        class="font-semibold px-4 py-2 h-8 rounded u-center"
        :class="{ 'bg-[#1A276A]': gameName === 'emojile', 'bg-[#6E37AF]': gameName === 'bilpop' }"
        :href="`/${gameName}?game=${game.id}`"
      >
        {{ game.playerStatus ? (game.playerStatus.gameStatus === 'done' ? 'Oynandı' : 'Devam Et') : 'Oyna' }}
      </OButton>
    </div>
    <OButton
      pure
      class="u-center bg-white px-2 py-4 mt-2 h-11 rounded-lg w-full"
      :href="`oyun/skor/${gameName}?month=${date.month()}&year=${date.year()}`"
    >
      <p class="text-13" :class="{ 'text-[#121C68]': gameName === 'emojile', 'text-[#44097C]': gameName === 'bilpop' }">
        Geçmiş Oyunları Gör
      </p>
      <ORawIcon icon="right" :svg-class="gameName === 'emojile' ? 'fill-[#121C68]' : 'fill-[#44097C]'" />
    </OButton>
  </div>
</template>
<script>
import { defineComponent, useAsync, useContext, ssrRef } from '@nuxtjs/composition-api';
import { upperFirst } from 'lodash';
import { OButton, OIcon, ORawIcon } from '~/modules/common/components/ui';
import { useAuth } from '~/modules/auth/state/useAuth';
import { localStore } from '~/modules/common/utils/localStorageUtils';
import { dayjs } from '~/modules/common/utils/dateUtils';

export default defineComponent({
  props: {
    gameName: String,
    startDate: Number,
  },
  components: { OButton, OIcon, ORawIcon },
  setup(props) {
    const games = ssrRef({});
    const { $service } = useContext();
    const { isLoggedIn } = useAuth();
    const _gameName = upperFirst(props.gameName);
    const date = dayjs(props.startDate);
    const getLastGames = async () => {
      try {
        const userParams = isLoggedIn.value ? { withStatuses: true } : {};
        const { data } = await $service.game.getPreviousGames({
          gameType: props.gameName,
          beforeTsInMs: props.startDate,
          ...userParams,
        });
        games.value = data;
        if (process.client) {
          for (const game of games.value) {
            setLocalGameData(game);
          }
        }
      } catch (err) {
        console.log(err);
      }
    };

    const setLocalGameData = (game) => {
      if (isLoggedIn.value) return;
      const data = localStore.getItem(`o-${props.gameName}`)?.[game.id];
      if (!data) return;
      const status = data.gameStatus === '' ? 'in progress' : data.gameStatus;
      game.playerStatus = { statusData: data, gameStatus: status, score: data.score };
    };

    const paddedNumber = (gameNumber) => {
      return String(gameNumber).padStart(4, '0');
    };

    useAsync(async () => {
      await getLastGames();
    });
    return { games, _gameName, paddedNumber, date };
  },
});
</script>
<style lang="scss" scoped>
.bg-tr {
  border-radius: 12px 0px 0px 12px;
  background: rgba(0, 0, 0, 0.15);
}
</style>
